export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  CRITICAL = 4
}

export interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  context?: any;
  source?: string;
  sessionId?: string;
  userId?: string;
  platform: 'server' | 'browser';
  url?: string;
  userAgent?: string;
  errorStack?: string;
}

export interface LogTransport {
  name: string;
  minLevel: LogLevel;
  log(entry: LogEntry): void | Promise<void>;
}

export interface LoggerConfig {
  minLevel: LogLevel;
  transports: LogTransport[];
  enableStackTrace: boolean;
  enableSourceMapping: boolean;
  maxRetries: number;
  bufferSize: number;
  flushInterval: number;
}